import {
  CreateInstituicaoEnsinoDto,
  ReadInstituicaoEnsinoDto,
  UpdateInstituicaoEnsinoDto,
} from '@/api.types';

function str(value: unknown): string {
  return value == null ? '' : String(value);
}

/** Normaliza resposta da API para o formulário (Zod não aceita `null` em string). */
export function normalizeInstituicaoFormFromApi(
  data: ReadInstituicaoEnsinoDto,
): ReadInstituicaoEnsinoDto {
  return {
    ...data,
    razao_social: str(data.razao_social),
    cnpj: str(data.cnpj),
    representante_nome: str(data.representante_nome),
    representante_cargo: str(data.representante_cargo),
    ordem: data.ordem ?? 0,
    endereco: {
      ...(data.endereco?.id != null ? { id: data.endereco.id } : {}),
      cep: str(data.endereco?.cep),
      cidade: str(data.endereco?.cidade),
      bairro: str(data.endereco?.bairro),
      logradouro: str(data.endereco?.logradouro),
      complemento: str(data.endereco?.complemento),
      numero: data.endereco?.numero ?? undefined,
    },
    telefone: {
      ...(data.telefone?.id != null ? { id: data.telefone.id } : {}),
      ddd: data.telefone?.ddd ?? 79,
      numero: str(data.telefone?.numero),
    },
  };
}

/** Payload enviado à API — apenas campos do DTO (auditoria fica no backend). */
export function buildInstituicaoSavePayload(
  data: ReadInstituicaoEnsinoDto,
  instituicaoId?: number,
): CreateInstituicaoEnsinoDto | UpdateInstituicaoEnsinoDto {
  const numeroTelefone = str(data.telefone?.numero).replace(/\D/g, '');

  return {
    ...(instituicaoId ? { id: instituicaoId } : {}),
    ordem: Number(data.ordem) || 0,
    razao_social: str(data.razao_social).trim(),
    cnpj: str(data.cnpj),
    representante_nome: str(data.representante_nome).trim() || undefined,
    representante_cargo: str(data.representante_cargo).trim() || undefined,
    endereco: {
      ...(data.endereco?.id != null ? { id: data.endereco.id } : {}),
      cep: str(data.endereco?.cep) || undefined,
      cidade: str(data.endereco?.cidade) || undefined,
      bairro: str(data.endereco?.bairro) || undefined,
      logradouro: str(data.endereco?.logradouro) || undefined,
      complemento: str(data.endereco?.complemento) || undefined,
      numero:
        data.endereco?.numero != null && String(data.endereco.numero).trim() !== ''
          ? Number(data.endereco.numero)
          : undefined,
    },
    telefone: {
      ...(data.telefone?.id != null ? { id: data.telefone.id } : {}),
      ddd: data.telefone?.ddd != null ? Number(data.telefone.ddd) : undefined,
      numero: numeroTelefone || undefined,
    },
  };
}
